module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/artefato/layout-arquivo/layout-arquivo.component.css
// module id = ./src/app/artefato/layout-arquivo/layout-arquivo.component.css
// module chunks = main